<template>
  <!--票务系统-->
  <article>
    <div class="caption">
      <h2>社会化服务</h2>
      <span>COMMERCIAL AGRICULTURAL SERVICES</span>
    </div>

    <div class="content">
      社会化管理服务是景区电商体系的重要内容，是顺利推进全网售票、分时预约的重要保障条件，是维护景区保障游客合法权益的有效手段
    </div>

    <div class="body">
      <div class="level-1">
        <img src="@/assets/images/product/commService/body-1.jpg" alt="" srcset="">
        <div class="card">
          <h4>FIELD SERVICE</h4>
          <h5>现场服务</h5>
          <p>提供客服呼叫中心，支持游客咨询及电话退票、改签、投诉等建议</p>
        </div>
        <div class="card-bg"></div>
      </div>
      <div class="level-2">
        <img src="@/assets/images/product/commService/body-2.jpg" alt="" srcset="">
        <div class="card">
          <h4>CUSTOM SERVICE</h4>
          <h5>电话客服</h5>
          <p>提供客服呼叫中心，支持游客咨询及电话退票、改签、投诉等建议</p>
        </div>
        <div class="card-bg"></div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data: function() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
article {
  display: flex;
  flex-direction: column;

  > .caption {
    display: flex;
    flex-direction: column;
    align-items: center;
    > h2 {
      display: inline-block;
      border-bottom: 2px solid #666666;
      padding-bottom: 5px;
      font-size: 24px;
    }

    span {
      font-size: 14px;
      font-weight: lighter;
    }
  }

  > .content {
    margin: 20px 0;
    text-align: center;
    font-size: 14px;
  }

  > .body {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    position: relative;
    width: 100%;
    margin: 20px 0;

    > .level-1 {
      width: 100%;
      position: relative;
      margin-bottom: 30px;

      > img {
        width: 70%;
        border: 1px dashed gray;
        z-index: 1;
      }

      > .card {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 18%;
        right: 20px;
        z-index: 3;
        border-radius: 0;
        padding: 40px;

        h4 {
          font-size: 0.14rem;
        }

        h5 {
          font-size: 0.12rem;
        }

        p {
          margin: 20px 0;
          font-size: 0.08rem;
        }
      }

      > .card-bg {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 22.3%;
        right: 0;
        background-color: rgba(20, 90, 132, 1);
        z-index: 2;
      }
    }

    > .level-2 {
      width: 100%;
      position: relative;
      text-align: right;

      > img {
        width: 70%;
        border: 1px dashed gray;
        right: 0;
        z-index: 1;
      }
      > .card {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 18%;
        left: 20px;
        z-index: 3;
        border-radius: 0;
        padding: 40px;
        text-align: left;

        h4 {
          font-size: 0.14rem;
        }

        h5 {
          font-size: 0.12rem;
        }

        p {
          margin: 20px 0;
          font-size: 0.08rem;
        }
      }
      > .card-bg {
        width: 40%;
        height: 60%;
        position: absolute;
        top: 22.3%;
        background-color: rgba(20, 90, 132, 1);
        z-index: 2;
      }
    }

    h4,
    h5 {
      margin-bottom: 0.05rem;
    }
  }
}
</style>